// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js!../../style/colors.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tOJhDW7XvOMx1ah0tc1M {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.tOJhDW7XvOMx1ah0tc1M label {
  font-family: Roboto, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  margin-bottom: 8px;
}

.tOJhDW7XvOMx1ah0tc1M input {
  height: 42px;
  border-radius: 5px;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]};
  padding: 8px;
  box-sizing: border-box;
}

.aFdR2tkbJNUdxPtMQpjA p {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]};
  font-size: 12px;
  margin-top: 4px;
}

.f8p75BK5tqMgdWr8_fYY input {
  border-color: red;
}

.gwYxPJLkkseMjLDyNBMO input {
  background-color: #F1F1F4;
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
  color: rgb(84, 84, 84);
  outline: none;
  cursor: not-allowed;
}

.tOJhDW7XvOMx1ah0tc1M input:focus {
  outline: none;

}

.tOJhDW7XvOMx1ah0tc1M input:focus-within, .mUmoPqQ71nlycvszcmTB, .tOJhDW7XvOMx1ah0tc1M input:hover {
  border-color: #526AF2;
  outline: none;
  transition: .3s;
  cursor: pointer;
}

.tOJhDW7XvOMx1ah0tc1M input:focus-within {
  box-shadow: 0 0 6px #b1bdff;
}

.gwYxPJLkkseMjLDyNBMO input:hover {
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
}

.gwYxPJLkkseMjLDyNBMO input:focus {
  border-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]};
  box-shadow: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/library/Input/CountryDropdown/CountryDropdown.module.css"],"names":[],"mappings":"AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,8DAAkC;EAClC,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,mDAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,0DAAwB;EACxB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;;AAEf;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0DAAwB;AAC1B;;AAEA;EACE,0DAAwB;EACxB,gBAAgB;AAClB","sourcesContent":["@value colors: \"../../style/colors.css\";\n@value color-error, color-gray-light, color-gray from colors;\n\n.country {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 16px;\n}\n\n.country label {\n  font-family: Roboto, sans-serif;\n  font-style: normal;\n  font-weight: normal;\n  font-size: 16px;\n  margin-bottom: 8px;\n}\n\n.country input {\n  height: 42px;\n  border-radius: 5px;\n  border: 1px solid color-gray-light;\n  padding: 8px;\n  box-sizing: border-box;\n}\n\n.hint p {\n  color: color-error;\n  font-size: 12px;\n  margin-top: 4px;\n}\n\n.error input {\n  border-color: red;\n}\n\n.disabled input {\n  background-color: #F1F1F4;\n  border-color: color-gray;\n  color: rgb(84, 84, 84);\n  outline: none;\n  cursor: not-allowed;\n}\n\n.country input:focus {\n  outline: none;\n\n}\n\n.country input:focus-within, .inputActive, .country input:hover {\n  border-color: #526AF2;\n  outline: none;\n  transition: .3s;\n  cursor: pointer;\n}\n\n.country input:focus-within {\n  box-shadow: 0 0 6px #b1bdff;\n}\n\n.disabled input:hover {\n  border-color: color-gray;\n}\n\n.disabled input:focus {\n  border-color: color-gray;\n  box-shadow: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"../../style/colors.css"`,
	"color-error": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-error"]}`,
	"color-gray-light": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray-light"]}`,
	"color-gray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["color-gray"]}`,
	"country": `tOJhDW7XvOMx1ah0tc1M`,
	"hint": `aFdR2tkbJNUdxPtMQpjA`,
	"error": `f8p75BK5tqMgdWr8_fYY`,
	"disabled": `gwYxPJLkkseMjLDyNBMO`,
	"inputActive": `mUmoPqQ71nlycvszcmTB`
};
export default ___CSS_LOADER_EXPORT___;
